var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('header',{staticClass:"login-header"},[_vm._t("logo")],2),_c('ResetPasswordForm',{attrs:{"token":_vm.token,"with-token":_vm.withToken},on:{"login":_vm.handleLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }